import { styled } from "styled-components";

export const Rect = styled.rect`
  transition: 0.3s;
`